export const SECTION_RESULT_LIMIT = 3;

export const RESULTS_PAGE_SIZE = 10;

export const SEARCH_TERM_MIN_LENGTH = 3;

export const SEARCH_TERM_MAX_LENGTH = 100;
